<script>
import { loadAssetWhiteLabel } from '@composables/utils/loadAsset.ts'
import { appImg } from 'tb-design_system-web'
import { onMounted } from 'vue'
import { useMeta } from 'vue-meta'
import { useRouter } from 'vue-router'

import RegisterLayout from '@/components/shared/registerLayout.vue'
import { getPlatformFromUrl, platformWhiteLabel } from '@/composables/utils/useWhitelabelService.js'
import { useOnboardingStore } from '@/stores/onboarding'

export default {
  name: 'AppRegister',
  components: {
    RegisterLayout,
    appImg
  },
  setup() {
    useMeta({ title: 'Register' })

    const router = useRouter()
    const onboardingStore = useOnboardingStore()

    const platform = getPlatformFromUrl()

    onMounted(() => {
      const queryParams = new URLSearchParams(window.location.search)
      const codePartner =
        platformWhiteLabel(platform, 'codePartner') || queryParams.get('codepartner')

      if (codePartner) {
        onboardingStore.setStepData(2, {
          subscriptionCode: codePartner
        })
      }
    })

    const pfImg = new URL('@/assets/img/svg/pf.svg', import.meta.url).href
    const pjImg = new URL('@/assets/img/svg/pj.svg', import.meta.url).href

    const selectType = (type) => {
      if (onboardingStore.typeClient !== type) {
        const subscriptionCode = onboardingStore.getStepData(2)?.subscriptionCode
        onboardingStore.resetState(true, type, subscriptionCode)
      }
      router.push(`/register/${type}`)
    }

    const redirect = () => {
      const url = platformWhiteLabel(platform, 'platformUrlRedirection')
      window.location.href = url
    }

    return {
      pfImg,
      pjImg,
      selectType,
      redirect,
      loadAssetWhiteLabel
    }
  }
}
</script>

<template>
  <RegisterLayout>
    <div class="col-12 col-md-9 d-flex align-items-center">
      <div class="w-100">
        <div class="row d-flex justify-content-center select-type">
          <div class="col-12 col-md-6 col-lg-5 d-flex flex-column align-items-center">
            <div class="row mb-5 logo">
              <app-img
                class="img-responsive mb-3"
                :src="loadAssetWhiteLabel('logo.svg')"
                alt="logo"
                height="33"
              />
            </div>

            <div class="text-center">
              <h4><b>Que tipo de cadastro você gostaria de criar?</b></h4>
            </div>

            <div class="row g-3 mb-5">
              <div class="col-12 col-md-6">
                <div class="text-center box" @click="selectType('PF')">
                  <img :src="pfImg" width="60" height="60" />
                  <h5>Pessoa física</h5>
                  <p>Para receber e enviar pagamentos usando sua conta pessoal.</p>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="text-center box" @click="selectType('PJ')">
                  <img :src="pjImg" width="60" height="60" />
                  <h5>Pessoa jurídica</h5>
                  <p>Para receber e enviar pagamentos usando a conta da sua empresa.</p>
                </div>
              </div>
            </div>

            <hr class="col-12 mb-0 mt-3" />
            <div class="or">OU</div>

            <div class="text-center">
              <p class="text-center acc mt-3 mb-5">
                Já possui uma conta?
                <a @click="redirect"
                  ><u><b>Login</b></u></a
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </RegisterLayout>
</template>

<style lang="scss">
@use 'tb-design_system-web/lib/assets/css' as *;

.select-type {
  h4 {
    font-size: 18px;
  }
  .box {
    margin-top: 25px;
    border: 1px solid #d9d9d9;
    border-radius: 20px;
    padding: 24px;
    cursor: pointer;
    @include transition();

    &:hover {
      background-color: #fafafa;
    }

    h5 {
      margin-top: 5px;
      font-size: 18px;
      font-weight: 600;
      margin-bottom: 10px;
    }

    p {
      font-size: 12px;
      line-height: 18px;
      margin-bottom: 0;
    }
  }

  .or {
    background-color: #fff;
    padding: 0px 8px;
    z-index: 999;
    font-size: 14px;
    margin-top: -10px;
    font-weight: 500;
  }

  hr {
    color: #696969;
  }
}
</style>
